import ImprumutatorStep from "./steps/ImprumutatorStep";
import ImprumutatStep from "./steps/ImprumutatStep";
import DetaliiStep from "./steps/DetaliiStep";
import RambursareStep from "./steps/RambursareStep";
import ConditiiStep from "./steps/ConditiiStep";
import PreviewStep from "./steps/PreviewStep";
import buildImprumutPDF from "./buildPDF";

const imprumutConfig = {
  buildPDF: buildImprumutPDF,
  title: "Contract de Imprumut Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un contract de imprumut conform art. 2158-2170 Cod Civil.",
  step1Benefit: "Conform art. 2158-2170 Cod Civil, cu opțiuni de dobândă",
  pdfFilename: "contract-imprumut.pdf",
  steps: [
    { id: "imprumutator", label: "Imprumutator", title: "Datele Imprumutatorului", icon: "💰", component: ImprumutatorStep },
    { id: "imprumutat", label: "Imprumutat", title: "Datele Imprumutatului", icon: "👤", component: ImprumutatStep },
    { id: "detalii", label: "Detalii", title: "Detalii Imprumut", icon: "📋", component: DetaliiStep },
    { id: "rambursare", label: "Rambursare", title: "Modalitate de Rambursare", icon: "📅", component: RambursareStep },
    { id: "conditii", label: "Conditii", title: "Conditii Contractuale", icon: "⚖️", component: ConditiiStep },
    { id: "preview", label: "Preview", title: "Previzualizare Contract", icon: "📄", component: PreviewStep },
  ],
  defaultData: {
    imprumutatorPJ: false,
    imprumutatorNume: "",
    imprumutatorCNP: "",
    imprumutatorCI: "",
    imprumutatorAdresa: "",
    imprumutatorFirma: "",
    imprumutatorCUI: "",
    imprumutatorRegCom: "",
    imprumutatorSediu: "",
    imprumutatorReprezentant: "",
    imprumutatPJ: false,
    imprumutatNume: "",
    imprumutatCNP: "",
    imprumutatCI: "",
    imprumutatAdresa: "",
    imprumutatFirma: "",
    imprumutatCUI: "",
    imprumutatRegCom: "",
    imprumutatSediu: "",
    imprumutatReprezentant: "",
    sumaImprumut: "",
    valuta: "RON",
    scopImprumut: "personal",
    tipDobanda: "fara",
    dobandaProcent: "10",
    dobandaIndice: "IRCC",
    dobandaMarja: "2",
    dobandaPlafon: "15",
    dataImprumut: "",
    dataRestituire: "",
    modalitateRestituire: "integral",
    nrRate: "12",
    penalizareActiva: false,
    penalizare: "0.1",
    garantieActiva: false,
    garantNume: "",
    garantCNP: "",
    garantCI: "",
    garantAdresa: "",
    garantSolidar: true,
    martori: false,
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "imprumutator") {
      if (data.imprumutatorPJ) {
        if (!data.imprumutatorFirma.trim() || data.imprumutatorFirma.trim().length < 2) {
          errors.imprumutatorFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.imprumutatorCUI.trim()) {
          errors.imprumutatorCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.imprumutatorCUI.trim())) {
          errors.imprumutatorCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.imprumutatorSediu.trim()) errors.imprumutatorSediu = "Sediul social este obligatoriu";
        if (!data.imprumutatorReprezentant.trim()) {
          errors.imprumutatorReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.imprumutatorReprezentant.trim().split(/\s+/).length < 2) {
          errors.imprumutatorReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.imprumutatorNume.trim()) {
          errors.imprumutatorNume = "Numele este obligatoriu";
        } else if (data.imprumutatorNume.trim().split(/\s+/).length < 2) {
          errors.imprumutatorNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.imprumutatorCNP.trim() && !/^\d{13}$/.test(data.imprumutatorCNP.trim())) {
          errors.imprumutatorCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.imprumutatorCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.imprumutatorCI.trim())) {
          errors.imprumutatorCI = "Format invalid (ex: RD 123456 sau RD 1234567)";
        }
        if (!data.imprumutatorAdresa.trim()) errors.imprumutatorAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "imprumutat") {
      if (data.imprumutatPJ) {
        if (!data.imprumutatFirma.trim() || data.imprumutatFirma.trim().length < 2) {
          errors.imprumutatFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.imprumutatCUI.trim()) {
          errors.imprumutatCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.imprumutatCUI.trim())) {
          errors.imprumutatCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.imprumutatSediu.trim()) errors.imprumutatSediu = "Sediul social este obligatoriu";
        if (!data.imprumutatReprezentant.trim()) {
          errors.imprumutatReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.imprumutatReprezentant.trim().split(/\s+/).length < 2) {
          errors.imprumutatReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.imprumutatNume.trim()) {
          errors.imprumutatNume = "Numele este obligatoriu";
        } else if (data.imprumutatNume.trim().split(/\s+/).length < 2) {
          errors.imprumutatNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.imprumutatCNP.trim() && !/^\d{13}$/.test(data.imprumutatCNP.trim())) {
          errors.imprumutatCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.imprumutatCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.imprumutatCI.trim())) {
          errors.imprumutatCI = "Format invalid (ex: MZ 654321 sau MZ 6543210)";
        }
        if (!data.imprumutatAdresa.trim()) errors.imprumutatAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "detalii") {
      const limiteSuma = { EUR: 50000, USD: 55000, RON: 250000 };
      const limitaCurenta = limiteSuma[data.valuta] || 250000;
      const suma = Number(data.sumaImprumut);

      if (!data.sumaImprumut || suma <= 0) {
        errors.sumaImprumut = "Suma imprumutata este obligatorie si trebuie sa fie mai mare ca 0";
      } else if (suma > limitaCurenta) {
        errors.sumaImprumut = `Suma maxima permisa este ${limitaCurenta.toLocaleString("ro-RO")} ${data.valuta}. Pentru sume mai mari, se recomanda contract notarial.`;
      }
      if (data.tipDobanda === "fixa") {
        const dob = Number(data.dobandaProcent);
        if (isNaN(dob) || dob < 0) {
          errors.dobandaProcent = "Dobanda trebuie sa fie minim 0%";
        } else if (dob > 20) {
          errors.dobandaProcent = "Dobanda nu poate depasi 20% pe an";
        }
      }
      if (data.tipDobanda === "variabila") {
        const marja = Number(data.dobandaMarja);
        const plafon = Number(data.dobandaPlafon);
        if (isNaN(marja) || marja < 0) {
          errors.dobandaMarja = "Marja trebuie sa fie minim 0%";
        } else if (marja > 10) {
          errors.dobandaMarja = "Marja nu poate depasi 10%";
        }
        if (isNaN(plafon) || plafon < 1) {
          errors.dobandaPlafon = "Plafonul trebuie sa fie minim 1%";
        } else if (plafon > 20) {
          errors.dobandaPlafon = "Plafonul nu poate depasi 20%";
        }
      }
    }

    if (stepId === "rambursare") {
      if (!data.dataImprumut) errors.dataImprumut = "Data acordarii imprumutului este obligatorie";
      if (!data.dataRestituire) {
        errors.dataRestituire = "Data restituirii este obligatorie";
      } else if (data.dataImprumut && new Date(data.dataRestituire) <= new Date(data.dataImprumut)) {
        errors.dataRestituire = "Data restituirii trebuie sa fie dupa data acordarii";
      }
      if (data.modalitateRestituire === "rate" && data.dataImprumut && data.dataRestituire) {
        const start = new Date(data.dataImprumut);
        const end = new Date(data.dataRestituire);
        const luniDisp = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
        if (Number(data.nrRate) > luniDisp) {
          errors.nrRate = `Numarul de rate (${data.nrRate}) depaseste perioada disponibila (${luniDisp} luni)`;
        }
      }
    }

    if (stepId === "conditii") {
      if (data.garantieActiva) {
        if (!data.garantNume || !data.garantNume.trim()) {
          errors.garantNume = "Numele garantului este obligatoriu";
        } else if (data.garantNume.trim().split(/\s+/).length < 2) {
          errors.garantNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.garantCNP && data.garantCNP.trim() && !/^\d{13}$/.test(data.garantCNP.trim())) {
          errors.garantCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.garantCI && data.garantCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.garantCI.trim())) {
          errors.garantCI = "Format invalid (ex: RD 123456)";
        }
        if (!data.garantAdresa || !data.garantAdresa.trim()) {
          errors.garantAdresa = "Adresa garantului este obligatorie";
        }
      }
    }

    return errors;
  },
};

export default imprumutConfig;
